import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator";
import { Stack } from "@fluentui/react/lib/Stack";
import React from "react";
import { IProgressProps } from "./IProgressProps";
import { useProgressStyles } from "./UseProgressStyles";

export function Progress(props: IProgressProps): JSX.Element {
  const { progress } = props;
  const styles = useProgressStyles();
  return (
    <Stack disableShrink verticalAlign="end" className={styles.root}>
      <Stack.Item>
        <ProgressIndicator percentComplete={progress} />
      </Stack.Item>
    </Stack>
  );
}
